import * as React from 'react';

export const WELCOME_REFERRAL = 'WelcomeReferral';
export const TOKENS = 'Tokens';
export const FULL_STORY_WEB_HOOKS = 'FULL_STORY_WEB_HOOKS';
export const FULL_STORY_ANALYTICS = 'FULL_STORY_ANALYTICS';
export const FULL_STORY_CONFIGURATION = 'FULL_STORY_CONFIGURATION';
export const IFTTT_WEB_HOOKS = 'IFTTT_WEB_HOOKS';
export const DISCONNECT_CLIENTS = 'DISCONNECT_CLIENTS';
export const FULL_STORY_WELCOME = 'FULL_STORY_WELCOME';
export const FULL_STORY_REPORTS = 'FULL_STORY_REPORTS';

const EnabledFeatures = [
  WELCOME_REFERRAL,
  TOKENS,
  DISCONNECT_CLIENTS,
  FULL_STORY_REPORTS,
];

export const FeatureDisabler = ({feature, children}) => {
  if (EnabledFeatures.includes(feature)) {
    return children;
  } else {
    return window.location.href.includes('test=true') ? children : <></>;
  }
};
export const FeatureToggle = ({feature, current, next}) => {
  if (EnabledFeatures.includes(feature)) {
    return next;
  } else {
    return window.location.href.includes('test=true') ? next : current;
  }
};
export const IsFeatureEnabled = (feature) => {
  if (EnabledFeatures.includes(feature)) {
    return true;
  } else {
    return !!window.location.href.includes('test=true');
  }
};
